// extracted by mini-css-extract-plugin
export default {"root":"pageTitle_root__6fH1o","title":"pageTitle_title__t3q0t","buttonsWrap":"pageTitle_buttonsWrap__UlXSE"};